import addWindowScrollPositionToDocument from './modules/viewport';
import carousels from './modules/carousels';
import Player from '@vimeo/player';
import './modules/featherlight';
import './modules/pagination';
import initSmoothScroll from "./modules/smoothscroll";

try {
  window.$ = window.jQuery = require('jquery');
} catch (e) {
}

addWindowScrollPositionToDocument();
carousels.blockSlider();
carousels.referenceSlider();
carousels.newsSlider();
carousels.productTextMediaSlider();
carousels.swiperMode();
initSmoothScroll();

const videoIframe = $('[data-video-player]');
const audioToggler = $('[data-toggle-audio]');
const audioIcon = $('[data-audio-icon]');

if (videoIframe.length > 0) {
  const player = new Player(videoIframe);
  player.ready().then(function () {
    audioToggler.on('click', function (e) {
      e.preventDefault();

      player.getMuted().then(function (muted) {
        if (muted === false) {
          audioIcon.addClass('fa-volume-mute');
          audioIcon.removeClass('fa-volume-up');
          player.setMuted(true);
        } else {
          audioIcon.removeClass('fa-volume-mute');
          audioIcon.addClass('fa-volume-up');
          player.setMuted(false);
        }
      });
    });
  });
}

$('[title]').removeAttr('title');

$(window).scroll(function () {
  if ($(this).scrollTop() > 100) {
    $('header.home').removeClass('lg:bg-transparent');
  } else {
    $('header.home').addClass('lg:bg-transparent');
  }
});

$('.toggle-navbar').click(function (e) {
  e.stopPropagation();
  $('#navbar').toggleClass('translate-x-full');
  $('body').toggleClass('overflow-hidden');
});

$('body,html').click(function (e) {
  $('#navbar').addClass('translate-x-full');
  $('body').removeClass('overflow-hidden');
});

//Tabs
$(function () {
  var activeIndex = $('.active-tab').index(),
    $contentlis = $('.tabs-content li'),
    $tabslis = $('.tabs li');

  // Show content of active tab on loads
  $contentlis.eq(activeIndex).show();

  $('.tabs').on('click', 'li', function (e) {
    var $current = $(e.currentTarget),
      index = $current.index();

    $tabslis.removeClass('active-tab');
    $current.addClass('active-tab');
    $contentlis.hide().eq(index).show();
  });
});

//Scroll to anchorpoint -100px
// The function actually applying the offset
function offsetAnchor() {
  if (location.hash.length !== 0) {
    window.scrollTo(window.scrollX, window.scrollY - 100);
  }
}

// Captures click events of all <a> elements with href starting with #
$(document).on('click', 'a[href^="#"]', function (event) {
  // Click events are captured before hashchanges. Timeout
  // causes offsetAnchor to be called after the page jump.
  window.setTimeout(function () {
    offsetAnchor();
  }, 0);
});

// Set the offset when entering page with hash present in the url
window.setTimeout(offsetAnchor, 0);

// Add padding top from breadcrumbs on mobile when uviscan sub-menu or sub-menu is active
const uviScanMenu = document.getElementById('uviscan-menu');
const subMenu = document.getElementById('sub-menu');
const breadcrumbs = document.getElementById('breadcrumbs');

if(window.innerWidth < 768 && uviScanMenu != null && breadcrumbs != null){
  breadcrumbs.classList.remove('pt-4');
  breadcrumbs.classList.add('pt-16');
}

if(window.innerWidth < 768 && subMenu != null && breadcrumbs != null){
  breadcrumbs.classList.remove('pt-4');
  breadcrumbs.classList.add('pt-16');
}

// Change video on home on mobile
const homeVideoWrapper = document.getElementsByClassName('home-video-wrapper')[0];

if(window.innerWidth < 1024 && homeVideoWrapper != null) {
  homeVideoWrapper.innerHTML = '<video loop autoplay muted playsinline background id="mobile-home-video">' +
    '<source type="video/mp4" src="https://player.vimeo.com/external/575265434.sd.mp4?s=2db13143c94f1665ca075c93a2e329964142e962&profile_id=164&background=1&playsinline=1&muted=1">' +
    '</video>';
}


